/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_105Inputs */

const cs_ares_legal_form_105 = /** @type {(inputs: Ares_Legal_Form_105Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyzická osoba — zemědělský podnikatel`)
};

const en_ares_legal_form_105 = /** @type {(inputs: Ares_Legal_Form_105Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural person — farmer`)
};

/**
* | output |
* | --- |
* | "Natural person — farmer" |
*
* @param {Ares_Legal_Form_105Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_105 = /** @type {((inputs?: Ares_Legal_Form_105Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_105Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_105(inputs)
	return cs_ares_legal_form_105(inputs)
});